import { Box } from '@mui/material'
import EyeIcon from '@mui/icons-material/RemoveRedEye'
import { formatReadAt } from '~/shared/lib/date'

const ChatReadReceipt: React.FC<{ readAt: string }> = props => {
  return (
    <Box
      sx={{ width: '100%', display: 'flex', alignItems: 'center' }}
      data-testid="chat-read-receipt"
    >
      <Box sx={{ flex: 1, borderTop: '1px solid', borderTopColor: 'divider' }} />
      <Box
        sx={{
          margin: '0.5rem',
          color: 'grey.500',
          fontSize: '1.1rem',
          display: 'flex',
          alignItems: 'center',
          fontWeight: 500,
        }}
      >
        <EyeIcon fontSize="small" sx={{ color: 'grey.300', mr: 0.5 }} />
        <span>{formatReadAt(new Date(props.readAt))}</span>
      </Box>
    </Box>
  )
}

export default ChatReadReceipt
